import { useState } from 'react';
import { glossaryTerms, glossaryCategories } from '../data/glossaryData';

export default function Glossary() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const filtered = glossaryTerms.filter(t => {
    const matchSearch = t.term.toLowerCase().includes(search.toLowerCase()) || t.definition.toLowerCase().includes(search.toLowerCase());
    const matchCat = activeCategory === 'all' || t.category === activeCategory;
    return matchSearch && matchCat;
  });

  const filterBtn = (active) => ({
    padding: '4px 12px', borderRadius: 'var(--radius-sm)',
    border: `1.5px solid ${active ? 'var(--color-primary)' : 'var(--color-border)'}`,
    cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600,
    fontFamily: 'var(--font-body)', letterSpacing: '0.04em',
    background: active ? 'var(--color-primary)' : 'var(--color-bg-white)',
    color: active ? '#fafaf8' : 'var(--color-text-muted)', transition: 'all 0.2s',
  });

  return (
    <div className="page-content">
      <div className="container">
        <span className="gold-tag">Ressources</span>
        <h1>Glossaire immobilier israélien</h1>
        <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem' }}>Les termes clés de l'immobilier israélien expliqués en français.</p>

        <div style={{ marginBottom: '1.5rem' }}>
          <input className="form-input" style={{ maxWidth: 400 }} type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher un terme..." />
        </div>

        <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
          <button style={filterBtn(activeCategory === 'all')} onClick={() => setActiveCategory('all')}>Tous</button>
          {glossaryCategories.map(c => <button key={c} style={filterBtn(activeCategory === c)} onClick={() => setActiveCategory(c)}>{c}</button>)}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {filtered.map((term, i) => (
            <div key={i} style={{ background: 'var(--color-bg-white)', borderRadius: 'var(--radius-md)', padding: '1.25rem 1.5rem', border: '1px solid var(--color-border)', borderLeft: '3px solid var(--color-accent)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', color: 'var(--color-primary)' }}>{term.term}</strong>
                <span className="badge badge-neutral">{term.category}</span>
              </div>
              <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.7, color: 'var(--color-text)' }}>{term.definition}</p>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--color-text-muted)' }}>
              <p>Aucun terme ne correspond à votre recherche.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
